module.exports = __webpack_public_path__ + "img/icon_server_down.d301436e.svg";